import { AwaitContainer } from '@ibsys/kit';
import { FC, useMemo } from 'react';
import { UpdateProfileRequest, useMyProfile } from '@/entities/profile';
import { MainInfoForm } from './MainInfoForm';
import { ReadonlyInfoCard } from './ReadonlyInfoCard';
import { PageContainer } from '@/shared/ui';

// Container: ProfilePage
export const ProfilePage: FC = () => {
  const { data, isLoading } = useMyProfile();

  const defaultValues: UpdateProfileRequest = useMemo(
    () => ({ firstName: data?.firstName || '', lastName: data?.lastName || '', email: data?.email || '' }),
    [data?.firstName, data?.lastName, data?.email],
  );

  return (
    <PageContainer>
      <AwaitContainer className="grid grid-cols-1 grid-rows-[auto_auto] w-full gap-5 pb-5 z-50" isLoading={isLoading}>
        <MainInfoForm defaultValues={defaultValues} />
        <ReadonlyInfoCard profile={data} />
      </AwaitContainer>
    </PageContainer>
  );
};
